import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserAvailabilityInput } from '../model/user.availability.input';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateCoachAvailabilitiesInput {
	readonly id: string;
	readonly timeZone: string;
	readonly availabilities: UserAvailabilityInput[];
}

export interface UpdateCoachAvailabilitiesParams {
	input: UpdateCoachAvailabilitiesInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateCoachAvailabilitiesApiMutation extends ApiMutation<
	UserOutput,
	UpdateCoachAvailabilitiesParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateCoachAvailabilities($input: UpdateCoachAvailabilitiesInput!) {
			updateCoachAvailabilities(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'updateCoachAvailabilities';
}
